export const LAPTOP_WIDTH = 1024;
export const MOBILE_WIDTH = 790;
export const SMALL_MOBILE_WIDTH = 425;
